






































/* Created- 26 - Aug - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { PartnerClient, UserDTO, AccessDetailsDTO, ContentStreamStoreDTO, PartnerSubscriptionDTO, IPartnerClient } from "../../Generated/ParticaAPI";
import { IAccountToken, AccountToken } from "../../Login/customauthservice";
import axios from "axios";


@Component(
	{
		name: "PartnerTest",
		components: { ParticaRowContainer, ParticaColumnContainer, ParticaCard }
	})
export default class PartnerTest extends Vue {
	private partnerKey: string = "";
	private tenantUser: string = "";
	private tenantPwd: string = "";
	private tenantToken: string = "";
	private userToken: string = "";
	private api: IPartnerClient;
	private bearer: IAccountToken;
	private email: string = "";
	private externalId: string = "";
	private stream: string = "";
	private access: string = "";
	private clienttoken: boolean = false;
	private currenttoken: string = "";
	private articleid: string = "";

	private async getUserToken() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));
			const user: UserDTO = new UserDTO();
			user.partnerId = this.partnerKey;
			user.emailAddress = this.email;
			user.externalId = this.externalId;
			console.log("Getting user token");
			console.log(user);
			const token: AccessDetailsDTO = await this.api.getAccessDetails(user);
			if (token !== undefined) {
				this.userToken = token.token as string;
			}
		} catch (err) {
			console.log(err);
			alert(err.message);
		}

	}

	private async getStreams() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));

			const subs: ContentStreamStoreDTO[] = await this.api.getStreams(this.partnerKey);
			console.log("Available streams");
			console.log(subs);
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}

	private async subscribe() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));

			const sub: PartnerSubscriptionDTO = new PartnerSubscriptionDTO();
			sub.externalId = this.externalId;
			sub.partnerId = this.partnerKey;
			sub.streamId = this.stream;
			sub.emailAddress = this.email;
			const result = await this.api.subscribeToContentStream(sub);
			console.log(result);
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}

	private async getFeeds() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));

			const result = await this.api.getFeeds(this.partnerKey, this.externalId);
			console.log(result);
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}


	private async getFeed() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));

			const result = await this.api.getFeed(this.partnerKey, this.externalId, this.stream);
			console.log(result);
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}

	private async getArticle() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));

			const result = await this.api.getArticle(this.partnerKey, this.externalId, this.articleid);
			console.log(result);
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}

	private async getSubscriptions() {
		try {
			this.currenttoken = this.tenantToken;
			if (this.clienttoken === true) {
				this.currenttoken = this.userToken;
			}
			this.api = new PartnerClient(undefined, axios.create({
				transformRequest: [
					(data, headers) => {
						headers.common.Authorization = "Bearer " + this.currenttoken;
						return data;
					}
				]
			}));

			const result = await this.api.getSubscriptions(this.partnerKey, this.externalId);
			console.log(result);
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}

	private async getTenantToken() {
		try {
			const token: any = await this.bearer.getToken(this.tenantUser, this.tenantPwd);
			this.tenantToken = token.access_token;
		} catch (err) {
			console.log(err);
			alert(err.message);
		}
	}

	private mounted() {
		this.api = new PartnerClient(undefined, axios.create({
			transformRequest: [
				(data, headers) => {
					delete headers.common.Authorization;
					return data;
				}
			]
		}));
		this.bearer = new AccountToken();
	}

}
